<div class="container my-4">
  <!-- ALERTA -->
  <div class="alert alert-custom mb-4" *ngIf="postosSemPreco.length">
    <div class="fw-semibold mb-2">
      Atenção: Os acordos não serão criados para os seguintes postos, devido ao
      preço bomba não ter sido cadastrado.
    </div>
    <div class="fw-bold" *ngFor="let p of postosSemPreco">
      {{ p.codPosto }} - {{ p.nomeReduzido }}<br />
    </div>
  </div>
  <!-- {{ precoFinalSugerido | json }}
  {{ indCombustivel | json }}
  {{ tipoAcordoEnum | json }} -->

  <div class="card card-custom shadow-sm">
    <!-- HEADER -->
    <div class="card-body">
      <div class="row align-items-end g-3 mb-4">
        <div class="col-md-4">
          <label class="form-label text-muted">Preço do acordo</label>
          <input
            type="text"
            class="form-control input-custom"
            currencyMask
            [options]="{
              prefix: 'R$ ',
              thousands: '.',
              decimal: ',',
              precision: 2
            }"
            [(ngModel)]="precoFinalLocal"
            (ngModelChange)="onPrecoFinalChange()"
          />
        </div>

        <div class="col-md-3">
          <button class="btn-fundo-vermelho w-100" (click)="recalcularPrecos()">
            Recalcular
          </button>
        </div>
      </div>
      <!-- TABELA -->
      <div class="table-responsive table-container box-sombra">
        <table class="table table-custom align-middle">
          <thead>
            <tr>
              <th>Posto</th>
              <th class="text-center">Preço Bomba</th>
              <th class="text-center">
                {{ tipoAcordoEnum == 5 ? "Desconto" : "Acrescimo" }}
              </th>
              <th class="text-center">Preço Final</th>
              <th width="60"></th>
            </tr>
          </thead>

          <tbody>
            <tr *ngIf="invalidPrecoSugerido.length > 0">
              <td colspan="5" class="text-center text-danger fw-bold">
                {{ msgPrecoSugeridoInvalido }}
              </td>
            </tr>
            <ng-container *ngFor="let item of precos">
              <tr [class.tr-preco-invalido]="isPrecoSugeridoInvalido(item)">
                <td>{{ item.codPosto }} - {{ item.nomePosto }}</td>
                <td>
                  <input
                    class="form-control input-custom text-center"
                    type="text"
                    currencyMask
                    [options]="{
                      prefix: 'R$ ',
                      thousands: '.',
                      decimal: ',',
                      precision: 2
                    }"
                    [ngModel]="item.precoUnitario"
                    disabled
                  />
                </td>

                <td>
                  <input
                    class="form-control input-custom text-center"
                    type="text"
                    currencyMask
                    [ngClass]="
                      valorNegativo(item.descontoAcrescimo || 0)
                        ? 'valor-negativo'
                        : ''
                    "
                    [options]="{
                      prefix: 'R$ ',
                      thousands: '.',
                      decimal: ',',
                      precision: 2
                    }"
                    [ngModel]="getValorAbsoluto(item.descontoAcrescimo)"
                    disabled
                  />
                </td>

                <td>
                  <input
                    class="form-control input-final text-center"
                    type="text"
                    currencyMask
                    [options]="{
                      prefix: 'R$ ',
                      thousands: '.',
                      decimal: ',',
                      precision: 2
                    }"
                    [ngModel]="item.precoFinal"
                    disabled
                  />
                </td>

                <td class="text-center">
                  <button
                    class="btn btn-sm btn-delete"
                    (click)="removerPostoDaLista(item.codPosto)"
                  >
                    🗑
                  </button>
                </td>
              </tr>
            </ng-container>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>

<div class="mt-4 text-end">
  <button
    style="margin-right: 8px"
    mat-button
    class="btn-fundo-claro"
    (click)="
      cancelarConfirmacao.emit();
      precoFinalSugeridoAlterado.emit(precoFinalLocal)
    "
  >
    Voltar
  </button>
  <button
    class="btn-fundo-vermelho btn-acao"
    *ngIf="(precos?.length || 0) > 0"
    [disabled]="invalidPrecoSugerido.length > 0"
    (click)="confirmarDescontos.emit(precos)"
  >
    Confirmar Descontos
  </button>
</div>
